module.exports = __webpack_public_path__ + "img/3701da3.jpg";